// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"0cb8ab53","453":"6ae337d6","656":"08c02c83","805":"3cd699a9","874":"ae0ec17e"}[chunkId] + ".chunk.js";
};